import { createSelector } from '@reduxjs/toolkit'
import { useAppSelector } from 'app/state'
import { RootState } from 'app/state/store'
import { FeatureFlag, FeatureFlagSet } from 'app/types'
export { FeatureFlag } from 'app/types'

export const selectActualFeatureFlags = createSelector(
  (state: RootState) => state.common.featureFlagsFromLd,
  (state: RootState) => state.common.featureFlagOverrides,
  (ldsAccountFlags, featureFlagOverrides): FeatureFlagSet => {
    return { ...ldsAccountFlags, ...featureFlagOverrides } as FeatureFlagSet
  }
)

export function useBooleanFeatureFlag(ff: FeatureFlag): boolean {
  const allFlags = useAppSelector(selectActualFeatureFlags)
  return Boolean(allFlags[ff])
}

export function useStringFeatureFlag(ff: FeatureFlag): string {
  const allFlags = useAppSelector(selectActualFeatureFlags)
  const stringValue = allFlags[ff]
  return stringValue ? stringValue.toString() : ''
}

export function useFeatureFlag(ff: FeatureFlag): boolean {
  // We save flags in the store instead of use useFlags hook to be able to read flags in places other than a component
  return useBooleanFeatureFlag(ff)
}

export function useFeatureFlagCheckCallback(): (ff: FeatureFlag) => boolean {
  const allFlags = useAppSelector(selectActualFeatureFlags)
  return (ff: FeatureFlag) => Boolean(allFlags[ff])
}
